import download from "../../images/logo/download.svg";


export const textBoxStyle = {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    color: "white",
    textAlign: "center",
    px: {xs: 3, md: 6},
    zIndex: 2, // Ensure text is above the image
};

export const mainLogoStyle = {
    // width: {
    //     xs: '95%',
    //     sm: '80%',
    //     md: '60%',
    //     lg: '40%',
    // },
    height: {
        xs: '60px',
        sm: '80px',
        md: '90px',
        lg: '100px',
    },
    width: 'auto',
    aspectRatio: '6 / 1',
    // height: 'auto',
    backgroundImage: `url(${download})`,
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
};

export const mainPageSubtitle = {
    mt: '-10px',
    fontSize: {
        xs: '20px',
        sm: '22px',
        md: '23px',
        lg: '24px',
    },
    fontFamily: 'Jost-Regular',
    color: "white",
    textAlign: 'center'
};

export const readyToTravelContainer = {
    position: 'relative',
    top: {
        xs: '86%',
        sm: '86%',
        md: '86%',
        lg: '86%',
    },
    left: {
        xs: 'calc(50% - 120px)',
        sm: 'calc(50% - 120px)',
        md: 'calc(50% - 125px)',
        lg: 'calc(50% - 125px)',
    }
}

export const readyToTravel = {
    background: "rgba(255, 255, 255, 0.2)",
    mt: 4,
    borderColor: "white",
    borderRadius: '0',
    color: "white",
    zIndex: 10,
    "&:hover": {backgroundColor: "rgba(255, 255, 255, 0.4)", color: "white"},
    width: {
        xs: '240px',
        sm: '240px',
        md: '250px',
        lg: '250px',
    },
    height: {
        xs: '48px',
        sm: '48px',
        md: '50px',
        lg: '50px',
    },
    fontSize: {
        xs: '19px',
        sm: '19px',
        md: '20px',
        lg: '20px',
    },
};
